<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <h2>个人登录</h2>
      </div>

      <el-form
        ref="loginFormRef"
        :model="loginForm"
        :rules="loginRules"
        class="login-form"
        size="large"
      >
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            clearable
            placeholder="请输入用户名"
            prefix-icon="el-icon-user"
          />
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            clearable
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            show-password
            type="password"
            @keyup.enter="handleLogin"
          />
        </el-form-item>

        <el-form-item>
          <el-button
            :loading="loading"
            class="login-btn"
            type="primary"
            @click="handleLogin"
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>

      <div class="login-footer">
        <el-button type="text" @click="goBack">返回首页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'

export default {
  name: 'PersonalLogin',
  setup () {
    const store = useStore()
    const router = useRouter()
    const loginFormRef = ref(null)
    const loading = ref(false)

    const loginForm = reactive({
      username: '',
      password: ''
    })

    const loginRules = {
      username: [
        {
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        },
        {
          min: 2,
          max: 50,
          message: '用户名长度应为2-50个字符',
          trigger: 'blur'
        }
      ],
      password: [
        {
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        },
        {
          min: 6,
          max: 20,
          message: '密码长度应为6-20个字符',
          trigger: 'blur'
        }
      ]
    }

    const handleLogin = async () => {
      if (!loginFormRef.value) return

      try {
        const valid = await loginFormRef.value.validate()
        if (!valid) return

        loading.value = true

        // 使用 store action 进行个人登录
        await store.dispatch('user/personalLogin', loginForm)

        ElMessage.success('登录成功')

        // 跳转到首页
        router.push('/')
      } catch (error) {
        console.error('登录错误:', error)
        ElMessage.error(error.message || '登录失败，请检查用户名和密码')
      } finally {
        loading.value = false
      }
    }

    const goBack = () => {
      router.push('/')
    }

    return {
      loginFormRef,
      loginForm,
      loginRules,
      loading,
      handleLogin,
      goBack
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-box {
  width: 100%;
  max-width: 400px;
  background: white;
  border-radius: 12px;
  padding: 40px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
}

.login-header {
  text-align: center;
  margin-bottom: 40px;

  .logo {
    width: 80px;
    height: 80px;
    margin-bottom: 20px;
  }

  h2 {
    color: #333;
    font-size: 28px;
    font-weight: 600;
    margin: 0;
  }
}

.login-form {
  .el-form-item {
    margin-bottom: 20px;

    :deep(.el-input__inner) {
      height: 48px;
      line-height: 48px;
      border-radius: 8px;
      font-size: 16px;

      &:focus {
        border-color: #6E38F7;
        //box-shadow: 0 0 0 2px rgba(110, 56, 247, 0.1);
      }
    }

    :deep(.el-input__prefix) {
      color: #999;
    }
  }
}

.login-btn {
  width: 100%;
  height: 48px;
  background: linear-gradient(135deg, #6E38F7 0%, #9333ea 100%);
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(110, 56, 247, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
}

.login-footer {
  text-align: center;
  margin-top: 30px;

  .el-button--text {
    color: #999;
    font-size: 14px;

    &:hover {
      color: #6E38F7;
    }
  }
}

// 响应式设计
@media (max-width: 480px) {
  .login-container {
    padding: 10px;
  }

  .login-box {
    padding: 30px 20px;
  }

  .login-header {
    margin-bottom: 30px;

    .logo {
      width: 60px;
      height: 60px;
    }

    h2 {
      font-size: 24px;
    }
  }
}
</style>
